import type { DetailedPinWithChecked } from '../all-pins/AllPins';
import type { DesignBoardsPinsLoaderData } from '~/routes/_app.member.design-boards.pins';

interface UpdateAllBoardsProps {
    checked: boolean;
    pinListWithChecked: DetailedPinWithChecked[];
    setPinListWithChecked: (boardsChecked: DetailedPinWithChecked[]) => void;
}

interface UpdateCheckProps extends UpdateAllBoardsProps {
    boardId: number;
    selectAllUpdate?: boolean;
}

export const pinsWithCheckedPins = (
    pinsData: DesignBoardsPinsLoaderData['allPinsData']
) => {
    return pinsData.map((p) => {
        return {
            ...p,
            checked: false,
        };
    });
};

export const updateAllBoards = ({
    checked,
    pinListWithChecked,
    setPinListWithChecked,
}: UpdateAllBoardsProps) => {
    const boardsChecked = pinListWithChecked.map((bl) => {
        return { ...bl, checked };
    });
    setPinListWithChecked(boardsChecked);
};

export const updateCheck = ({
    boardId,
    checked,
    pinListWithChecked,
    setPinListWithChecked,
}: UpdateCheckProps) => {
    const boardsChecked = pinListWithChecked.map((bl) => {
        if (bl?.ID === boardId) return { ...bl, checked };
        return bl;
    });
    setPinListWithChecked(boardsChecked);
};
